export default __webpack_public_path__ + "static/media/13.dbdf4313.PNG";